module.exports = __webpack_public_path__ + "static/media/hour.57e66e1f.jpg";